import { NEW_API_ROUTE_ADMIN_DRILL_DOWN_SERVICE_CATEGORY_GROUPS_COST_OBJECTS } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { DrillDownParamsOriginal, EntityOriginal, ListResponse } from './types'

import type { ReportEntityWithQuantity } from '../../drilldown/types'

type ProductCostObjectGroupCategoryResponse = ListResponse<CostObject> & {
  category: EntityOriginal
  group: EntityOriginal
  product: EntityOriginal
}

type CostObject = ReportEntityWithQuantity & {
  costObjectId: number
  costObjectName: string
  costObjectCode: string
  countryId: number
  amount: number
  totalAmount?: number
  salaryDeductionAmount: number
}

const IS_NEW_BACKEND_API = true

export const getDrillDownCostObjects = async (params: DrillDownParamsOriginal) => {
  const query = new URLSearchParams({ ...params })

  const productResult = await get<ProductCostObjectGroupCategoryResponse>(
    `${NEW_API_ROUTE_ADMIN_DRILL_DOWN_SERVICE_CATEGORY_GROUPS_COST_OBJECTS}?${query.toString()}`,
    IS_NEW_BACKEND_API
  )

  return {
    ...productResult,
    rows: productResult.rows.map(product => ({
      ...product,
      amount: Number(product.amount),
      salaryDeductionAmount: Number(product.salaryDeductionAmount),
    })),
  }
}
